import UltMeta, { Meta } from "./UltMeta/index";

//用户预付款记录
class State extends UltMeta {
    SUCCESS = new Meta(1, "成功");
    REVOKE = new Meta(2, "撤销");
}

export const STATE = new State();
